import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const navigationPaneComponent = {
  garageLink: 'navigation-pane.garage-link',
  root: 'navigation-pane.root',
  signOutLink: 'navigation-pane.signout-link',
  userName: 'navigation-pane.user-name',
} as const satisfies ComponentLocatorMap;
